/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  configure-apu-reducer.ts
 *
 * Project Title :  Checkout
 *
 * Description	 :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Srinivas Grandhi (E528634)
 *
 * @Date	     : Sep 25, 2019
 *
 * @Version      : Version 1.0
 *
 * By           : Deepthi Bachu (E844276)
 * On           : Oct 03, 2019
 * Description  : Updated code as per ASDS-1470
 *
 * By           : Deepthi Bachu (E844276)
 * On           : Oct 10, 2019
 * Description  : Updated code as per ASDS-1471
 *
 * By           : Deepthi Bachu (E844276)
 * On           : Oct 17, 2019
 * Description  : Updated code as per ASDS-1583
 *
 * By           : Madhu Gali - H175591
 * On           : 18 Oct 2019
 * Description  : ASDS-1549
 *
 * By           : Deepthi Bachu (E844276)
 * On           : Oct 24, 2019
 * Description  : Updated code as per ASDS-404, ASDS-115
 *
 * By           : Deepthi Bachu (E844276)
 * On           : Oct 30, 2019
 * Description  : Updated code as per ASDS-673
 *
 * By            : E807238
 * On            : Nov 1, 2019
 * Description   : ASDS-1673: Add To Cart Conformation UI & Integration
 *
 * By            : E844276
 * On            : Nov 18, 2019
 * Description   : Added generic product functionalities - removed from products
 *
 * By           : H224423
 * On           : Nov 28, 2019
 * Description  : ASDS-1474 Accept product terms changes.
 *
 * By            : Deepthi Bachu - E844276
 * On            : 28 Nov, 2019
 * Description   : ASDS-1961 - loader/message while loading contract numbers in APU MSA flow
 *
 * By            : Madhu Gali - H175591
 * On            : Dec 03 2019
 * Description   : ASDS-1964
 *
 * By            : H224423
 * On            : 12 Dec, 2019
 * Description   : Terms Checkbox default checked issue fix.
 *
 * By            : H224423
 * On            : Feb 26, 2019
 * Description   : ASDS-2349 - APU Product Features API Integration changes
 *
 * By            : H224423
 * On            : 10 Apr, 2020
 * Description   : ASDS-2497 - SIT Issue fixes. Contracts and sub-products API error handling.
 *
 * By             : H422337
 * On             : Sep 14,2020
 * Description    : ASDS-2753 UI enhancements as part of phase-2
 *
 * By             : H422337
 * On             : Sep 15,2020
 * Description    : ASDS-3038  NonMSAServiceOrder as part of phase-2
 *
 * By             : H422337
 * On             : Sep 18,2020
 * Description    : ASDS-3025 UI enhancements as part of phase-2
 * By             : H422337
 * On             : Sep 24,2020
 * Description    : ASDS-3026 APU enhancements as part of phase-2
 *
 * By            : H422336
 * On            : Sep 23, 2020
 * Description   : ASDS - 3020 - UI Enhancements for Phase - II
 *
 * By             : H422337
 * On             : Sep 25,2020
 * Description    : ASDS-3028 APU enhancements as part of phase-2
 *
 * By             : H422337
 * On             : Sep 29,2020
 * Description    : ASDS-3257 APU enhancements as part of phase-2
 *
 * By             : H422337
 * On             : Sep 30,2020
 * Description    : ASDS-3230 APU enhancements as part of phase-2
 *
 * By             : H422336
 * On             : Sep 29,2020
 * Description    : ASDS-3256 APU enhancements as part of phase-2
 *
 * By            : H422336
 * On            : Sep 29, 2020
 * Description   : ASDS - 3233 UI Enhancements for Phase - II
 *
 * By            : H422336
 * On            : Oct 9, 2020
 * Description   : ASDS - 3259 UI Enhancements for Phase - II
 *
 * By            : H422337
 * On            : Oct 08, 2020
 * Description   : Review Comments of UI Enhancements for Phase - II
 *
 * By            : H422337
 * On            : Oct 08, 2020
 * Description   : ASDS - 3438 UI Enhancements for phase-2 bugfixes
 *
 * By            : H422336
 * On            : Oct 11, 2020
 * Description   : ASDS - 3255 UI Enhancements for Phase - II
 *
 * By            : H422337
 * On            : Oct 09, 2020
 * Description   : ASDS - 3260 UI Enhancements for Phase - II
 *
 * By             : H422337
 * On             : Oct 14,2020
 * Description    : ASDS-3566 APU enhancements as part of phase-2
 *
 * By            : H422335
 * On            : 14 Oct 2020
 * Description   : ASDS-3035 Migration of DCE Endpoints to new Forge Environment API
 *
 * By            : H422337
 * On            : 29 Oct 2020
 * Description   : ASDS-3834 Highlight selected Non-MSA Purchase type 131-9 APU
 *

 ******************************************************************************/

import Reducer from './reducer';
import { AsdsReduxAction } from '../../../../types';
import { createReducer } from '../utils/redux-util';
import ActionConstants from '../action-constants';
import CheckoutConstants from 'modules/checkout/constants/checkout-constants';

class ConfigureAPUReducer extends Reducer {

    static saveApuCustomerType(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                customerType: action.payload.customerType,
                msaConfigData: action.payload.apuProductData,
                enableNextBtn: action.payload.enableNextBtn
            }
        };
    }

    static saveApuCustomerOrderType(state, action: AsdsReduxAction) {
        let newstate: any = {
              ...state
        }
        newstate.payload.customerOrderType = action.payload.customerOrderType
        newstate.payload.customerOrderTypeErrorMessage = action.payload.customerOrderTypeErrorMessage
        newstate.payload.enableNextBtn = action.payload.enableNextBtn
        newstate.payload.nonMsaConfigData = action.payload.nonMSAconfigData
        if(action.payload.customerOrderType === CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_KEY_ONLY) {
            newstate.payload.nonMsaKeyOnlyOrderConfigData = action.payload.nonMSAconfigData
        }
        else if(action.payload.customerOrderType === CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_SO) {
            newstate.payload.nonMsaServiceOrderConfigData = action.payload.nonMSAconfigData
        }
        return newstate;
    }

    static updateAircraftOEM(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                nonMsaConfigData: action.payload.apuProductData,
                enableNextBtn: action.payload.enableNextBtn
            }
        };
    }

    static updateApuSerialNumber(state, action: AsdsReduxAction) {
        let newState: any = {
            ...state,
        };
        newState.payload.enableNextBtn = action.payload.enableNextBtn;
        newState.payload.totalPrice = action.payload.totalPrice;
        if (action.payload.isKeyOnly) {
            newState.payload.nonMsaKeyOnlyOrderConfigData = action.payload.apuProductData;
        }
        else {
            newState.payload.nonMsaConfigData = action.payload.apuProductData;
        }
        return newState;
    }

    static gotoConfigureApuSerials(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                apuactiveTab: action.payload.apuactiveTab,
                enableNextBtn: action.payload.enableNextBtn,
            }
        };
    }

    static updateActiveTab(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                apuactiveTab: action.payload.apuactiveTab,
            }
        };
    }

    static apuBackButtonHandle(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                apuactiveTab: action.payload.apuactiveTab,
                enableNextBtn: action.payload.enableNextBtn
            }
        };
    }

    static onClickAPUConfigureButton(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                configureAPUModelOpen: action.payload.configureAPUModelOpen,
                categoryName: action.payload.categoryName,
                product: action.payload.product,
                system: action.payload.system,
                aircraftOEMs:action.payload.aircraftOEMType
            }
        };
    }

    static resetApuConfiguration(state) {  // reset the configure product modal data.
        return {
            payload: {
                ...state.payload,
                msaConfigData: [
                    {
                        soldToNum: '',
                        soldToError: '',
                        contractNum: '',
                        contractNumError: '',
                        expDate: '',
                        aircraftOem: '131-9A',
                        aircraftOemError: '',
                        serialNumber: '',
                        serialNumberError: '',
                        unitPrice: 0.00,
                        extendedPrice: '0.00',
                        error: '',
                        validInputData: false
                    }
                ],
                nonMsaConfigData: [
                    {
                        acOem: '131-9A',
                        oemError: '',
                        serialNumber: '',
                        serialNumberError: '',
                        paymentOption: '',
                        paymentOptionError: '',
                        unitPrice: 0.00,
                        extendedPrice: '0.00',
                        validInputData: false,
                        subProductId: '',
                        subProductDesc: '',
                        purchaseOrderNumber: '',
                        purchaseOrderNumberError: '',
                        expiryDate: ''
                    }
                ],
                nonMsaServiceOrderConfigData: [
                    {
                        acOem: '131-9A',
                        oemError: '',
                        serialNumber: '',
                        serialNumberError: '',
                        serviceOrderNumber: '',
                        serviceOrderNumberError: '',
                        paymentOption: '',
                        paymentOptionError: '',
                        unitPrice: 0.00,
                        extendedPrice: 0.00,
                        validInputData: false,
                        subProductId: '',
                        subProductDesc: ''
                    }
                ],

                nonMsaKeyOnlyOrderConfigData: [
                    {
                        acOem: '131-9A',
                oemError: '',
                serialNumber: '',
                serialNumberError: '',
                paymentOption: '',
                paymentOptionError: '',
                unitPrice: 0.00,
                extendedPrice: 0.00,
                validInputData: false,
                subProductId: '',
                optionId: '',
                optionError:'',
                optionAvailable: false,
                term: ''
                    }
                ],
                totalPrice: 0.0,
                isFetching: true,
                isSuccess: false,
                apuactiveTab: 1,
                enableNextBtn: false,
                configureAPUModelOpen: false,
                apuProductId: '',
                customerType: CheckoutConstants.CUSTOMER_CATEGORY_MSA, /* Setting Customer type default value to MSA for APU */
                customerOrderType: '',
                customerOrderTypeErrorMessage: '',
                redirectTo: undefined,
                acceptTermsStatus: false,
                acceptTermsErrorMsg: '',
                editCartAPUProductDetails: {
                    productSeq: 0,
                    seq: 0,
                   cartSeq: 0,
                   id: 0
                },
                contractData: [{
                    value: '',
                    text: '',
                }],
                contractDetails: [{
                    contractNo: '',
                    expiryDate: '',
                }],
                featuresMasterData: [],
                purchaseOrders: [],
                purchaseOrderDetails: [{
                    distributionNo: '',
                    endDate: '',
                }],
                showAPUValidationErrorMsg : true,
                isValidateServiceOrder: false,
                isValidateServiceOrderSuccess: true
            }
        };
    }

    // static addAPUProductToCart(state, action: AsdsReduxAction) {
    //     return {
    //         payload: {
    //             ...state.payload,
    //             productsInCart: action.payload.productsInCart,
    //         }
    //     };
    // }

    static setProductsInCart(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                productsInCart: action.payload.productsInCart,
            }
        };
    }

    // static gotoProductConfigureTab(state, action: AsdsReduxAction) {
    //     return {
    //         payload: {
    //             ...state.payload,
    //             apuactiveTab: action.payload.apuactiveTab,
    //         }
    //     };
    // }

    // static gotoCustomerCategoryTab(state, action: AsdsReduxAction) {
    //     return {
    //         payload: {
    //             ...state.payload,
    //             apuactiveTab: action.payload.apuactiveTab,
    //         }
    //     };
    // }

    static addNonMsaConfiguration(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                nonMsaConfigData: action.payload.updatedProductData,
                enableNextBtn: action.payload.enableNextBtn
            }
        };
    }

    static deleteNonMsaConfiguration(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                nonMsaConfigData: action.payload.updatedProductData,
                totalPrice: action.payload.totalPrice,
                enableNextBtn: action.payload.enableNextBtn
            }
        };
    }

    static updatePurchaseType(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                nonMsaConfigData: action.payload.apuProductData,
                enableNextBtn: action.payload.enableNextBtn,
                totalPrice: action.payload.totalPrice
            }
        };
    }

    static updateMSAData(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                msaConfigData: action.payload.apuProductData,
                enableNextBtn: action.payload.enableNextBtn,
                totalPrice: action.payload.totalPrice
            }
        };
    }

    // static updateAircraftOEMMSA(state, action: AsdsReduxAction) {
    //     return {
    //         payload: {
    //             ...state.payload,
    //             msaConfigData: action.payload.apuProductData,
    //             enableNextBtn: action.payload.enableNextBtn,
    //             totalPrice: action.payload.totalPrice
    //         }
    //     };
    // }

    static updateAPUSoldTo(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                msaConfigData: action.payload.apuProductData,
                enableNextBtn: action.payload.enableNextBtn
            }
        };
    }

    static modifyMsaConfiguration(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                msaConfigData: action.payload.updatedProductData,
                enableNextBtn: action.payload.enableNextBtn
            }
        };
    }

    // static deleteMsaConfiguration(state, action: AsdsReduxAction) {
    //     return {
    //         payload: {
    //             ...state.payload,
    //             msaConfigData: action.payload.updatedProductData,
    //             enableNextBtn: action.payload.enableNextBtn
    //         }
    //     };
    // }

    /**
     * @param state Method to map product details from mycart page to configure product object
     * @param action
     */
    static presetAPUProductDetails(state, action: AsdsReduxAction) {
        let newState: any = {
            ...state,
        };
        newState.payload.totalPrice = action.payload.product.totalPrice;
        newState.payload.enableNextBtn = false; // disabling next button - inorder to accept terms and condition
        newState.payload.product.productId = action.payload.product.prodId;
        newState.payload.product.productDesc = action.payload.product.prodDesc;
        newState.payload.system = action.payload.product.system;
        newState.payload.categoryName = action.payload.product.categoryName;
        newState.payload.product.productName = action.payload.product.prodName;

        newState.payload.customerType = action.payload.product.customerType.msa ? CheckoutConstants.CUSTOMER_CATEGORY_MSA : CheckoutConstants.CUSTOMER_CATEGORY_NONMSA;


        if (newState.payload.customerType === CheckoutConstants.CUSTOMER_CATEGORY_MSA) {
            newState.payload.msaConfigData = action.payload.productData;
        } else {
            if (action.payload.product.customerType.apuNonMsaSerials[0].subProductDesc === CheckoutConstants.NON_MSA_PURCHASE_ORDER) {
                newState.payload.nonMsaConfigData = action.payload.productData;
                newState.payload.customerOrderType = CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_PO;
            }
            else if (action.payload.product.customerType.apuNonMsaSerials[0].subProductDesc === CheckoutConstants.NON_MSA_SERVICE_ORDER) {
                newState.payload.nonMsaServiceOrderConfigData = action.payload.productData;
                newState.payload.customerOrderType = CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_SO;
            }
            else{
                newState.payload.nonMsaKeyOnlyOrderConfigData = action.payload.productData;
                newState.payload.customerOrderType = CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_KEY_ONLY;
            }
        }

        newState.payload.editCartAPUProductDetails = {
            id: action.payload.product.id,
            seq: action.payload.product.customerType.seq,
            cartSeq: action.payload.product.cartSeq,
            productSeq: action.payload.product.customerType.prodSeq
        };

        return newState;
    }

    static addContractData(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                contractData: action.payload.conData == null ? initialState.payload.contractData : action.payload.conData,
                contractDetails: action.payload.conDetails == null ? initialState.payload.contractDetails : action.payload.conDetails,
                isContractDataFetching: action.payload.isContractDataFetching,
                isContractDataSuccess: action.payload.isContractDataSuccess,
            }
        };
    }

    static closeApuModel(state) { // show product Successfully added to cart Alert model.
        return {
            payload: {
                ...state.payload,
                configureAPUModelOpen: false,
            }
        };
    }
    static updateAcceptTermsStatus(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                acceptTermsStatus: action.payload.acceptTermsStatus,
                acceptTermsErrorMsg: action.payload.acceptTermsErrorMsg,
                enableNextBtn: action.payload.enableNextBtn,
            }
        };
    }
    static setContractsLoading(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                isContractDataFetching: action.payload.isContractDataFetching,
                isContractDataSuccess: action.payload.isContractDataSuccess
            }
        };
    }

    static setSubProductsLoading(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                isProductFetching: action.payload.isProductFetching,
                isProductFetchSuccess: action.payload.isProductFetchSuccess
            }
        };
    }

    static updateExpiredContractsResponse(_state, action: AsdsReduxAction) {
        const { notifDisplayFlag, notifDisplayMsg, notifStatus } = action.payload;
        return {
            payload: {
                ..._state.payload,
                contractExpireNotif: {
                    notifDisplayFlag,
                    notifDisplayMsg,
                    notifStatus,
                }
            }
        };
    }
    static setProductFeatureList(_state, action: AsdsReduxAction) {
        const productFeaturesResponse: any = action.payload.featuresMasterData;
        return {
            payload: {
                ..._state.payload,
                featuresMasterData: productFeaturesResponse.length > 0 ? productFeaturesResponse : [],
                isProductFetching: action.payload.isProductFetching,
                isProductFetchSuccess: action.payload.isProductFetchSuccess
            }
        };
    }
    static hideAPUValidationErrorMsg(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                showAPUValidationErrorMsg: action.payload.showAPUValidationErrorMsg
            }
        };
    }
    static getPurchaseOrderDetails(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                purchaseOrders: action.payload.purchaseOrders,
                purchaseOrderDetails: action.payload.purchaseOrderDetails,
                isContractDataFetching: action.payload.isContractDataFetching,
                isContractDataSuccess: action.payload.isContractDataSuccess
            }
        };
    }

    static gotoProductConfigTab(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                apuactiveTab: action.payload.apuactiveTab,
                enableNextBtn: action.payload.enableNextBtn
            }
        };
    }

    static updatePurchaseOrderNumber(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                nonMsaConfigData: action.payload.apuProductData,
                enableNextBtn: action.payload.enableNextBtn,
                totalPrice: action.payload.totalPrice
            }
        };
    }

    /* Methods  for Non-MSA Service Order Configuration */
    static updateNonMsaSOSerial(state: any, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                nonMsaServiceOrderConfigData: action.payload.apuSOProductData,
                enableNextBtn : action.payload.enableNextBtn
            }
        };
    }
    static updateNonMsaServiceOrderNumber(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                nonMsaServiceOrderConfigData: action.payload.serviceOrderData,
                totalPrice: action.payload.totalPrice,
                enableNextBtn : action.payload.enableNextBtn
            }
        };
    }
    static addNonMsaServiceOrderConfiguration(state:any, action: AsdsReduxAction) {
        return {
            payload: {
                    ...state.payload,
                    nonMsaServiceOrderConfigData : action.payload.updatedProductData,
                    totalPrice: action.payload.totalPrice,
                    enableNextBtn : action.payload.enableNextBtn,
            }
        };
    }

   static apuNonMsaSoValidateApiError(state, action: AsdsReduxAction) {
        return {
                payload: {
                    ...state.payload,
                    isValidateServiceOrder: action.payload.isValidateServiceOrder,
                    isValidateServiceOrderSuccess: action.payload.isValidateServiceOrderSuccess,
                }
        };
   }

   /* Methods  for Non-MSA Key Only Order Configuration */
   static updateApuNonMsaKeyOnlySerialNumber(state: any, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                nonMsaKeyOnlyOrderConfigData: action.payload.apuKeyOnlyProductData,
                totalPrice: action.payload.totalPrice,
                enableNextBtn : action.payload.enableNextBtn
            }
        };
    }

    static addApuNonMsaKeyOnlyConfiguration(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                nonMsaKeyOnlyOrderConfigData: action.payload.updatedProductData,
                enableNextBtn: action.payload.enableNextBtn
            }
        };
    }
    static deleteApuNonMsaKeyOnlyConfiguration(state, action: AsdsReduxAction) {
        return {
            payload: {
                ...state.payload,
                nonMsaKeyOnlyOrderConfigData: action.payload.updatedProductData,
                totalPrice: action.payload.totalPrice,
                enableNextBtn: action.payload.enableNextBtn
            }
        };
    }
}

const apuConfigurationHandler = {
    [ActionConstants.APU_CONFIGURE_PRODUCT_MODEL]: ConfigureAPUReducer.onClickAPUConfigureButton,
    [ActionConstants.APU_SAVE_CUSTOMER_TYPE]: ConfigureAPUReducer.saveApuCustomerType,
    [ActionConstants.APU_SAVE_CUSTOMER_ORDER_TYPE]: ConfigureAPUReducer.saveApuCustomerOrderType,
    [ActionConstants.APU_GOTO_SERIAL_CONFIG]: ConfigureAPUReducer.gotoConfigureApuSerials, // go to 2nd tab
    [ActionConstants.APU_NONMSA_ADD_CONFIGURATION]: ConfigureAPUReducer.addNonMsaConfiguration,
    [ActionConstants.APU_NONMSA_DELETE_CONFIGURATION]: ConfigureAPUReducer.deleteNonMsaConfiguration,
    [ActionConstants.APU_UPDATE_AIRCRAFT_OEM]: ConfigureAPUReducer.updateAircraftOEM,
    [ActionConstants.APU_UPDATE_SERIAL_NUMBER]: ConfigureAPUReducer.updateApuSerialNumber,
    [ActionConstants.APU_UPDATE_PURCHASE_TYPE]: ConfigureAPUReducer.updatePurchaseType,
    [ActionConstants.APU_RESET_CONFIGURATION]: ConfigureAPUReducer.resetApuConfiguration,
    [ActionConstants.APU_GOTO_CUSTOMER_CATEGORY_TAB]: ConfigureAPUReducer.updateActiveTab,
    [ActionConstants.APU_GOTO_CONFIGURE_TAB]: ConfigureAPUReducer.gotoProductConfigTab,
    [ActionConstants.APU_GOTO_CONFIRM_CONFIG]: ConfigureAPUReducer.updateActiveTab,
    [ActionConstants.APU_BACK_BUTTON_HANDLE]: ConfigureAPUReducer.apuBackButtonHandle,
    [ActionConstants.APU_UPDATE_SERIAL_NUMBER_MSA]: ConfigureAPUReducer.updateMSAData,
    [ActionConstants.APU_UPDATE_AIRCRAFT_OEM_MSA]: ConfigureAPUReducer.updateMSAData,
    [ActionConstants.APU_UPDATE_SOLD_TO_MSA]: ConfigureAPUReducer.updateAPUSoldTo,
    [ActionConstants.APU_MSA_ADD_CONFIGURATION]: ConfigureAPUReducer.modifyMsaConfiguration,
    [ActionConstants.APU_MSA_DELETE_CONFIGURATION]: ConfigureAPUReducer.modifyMsaConfiguration,
    [ActionConstants.GOTO_PRODUCT_CONFIGURE_TAB]: ConfigureAPUReducer.updateActiveTab,
    [ActionConstants.ADD_APU_PRODUCT_TO_CART]: ConfigureAPUReducer.setProductsInCart,
    [ActionConstants.PRESET_CONFIGURE_APU_MYCART]: ConfigureAPUReducer.presetAPUProductDetails,
    [ActionConstants.LOAD_CART_DATA]: ConfigureAPUReducer.setProductsInCart,
    [ActionConstants.ADD_CONTRACT_DATA]: ConfigureAPUReducer.addContractData,
    [ActionConstants.CLOSE_APU_MODEL]: ConfigureAPUReducer.closeApuModel,
    [ActionConstants.UPDATE_APU_ACCEPT_TERMS_STATUS]: ConfigureAPUReducer.updateAcceptTermsStatus,
    [ActionConstants.SET_CONTRACTS_LOADING]: ConfigureAPUReducer.setContractsLoading,
    [ActionConstants.SET_SUB_PRODUCTS_LOADING]: ConfigureAPUReducer.setSubProductsLoading,
    [ActionConstants.UPDATE_EXPIRED_CONTRACTS_RESPONSE]: ConfigureAPUReducer.updateExpiredContractsResponse,
    [ActionConstants.SET_APU_PRODUCT_FEATURES]: ConfigureAPUReducer.setProductFeatureList,
    [ActionConstants.HIDE_VALIDATION_ERROR_MSG] : ConfigureAPUReducer.hideAPUValidationErrorMsg,
    [ActionConstants.GET_PURCHASEORDER_DETAILS]: ConfigureAPUReducer.getPurchaseOrderDetails,
    [ActionConstants.APU_UPDATE_CUSTOMER_PO_NONMSA]: ConfigureAPUReducer.updatePurchaseOrderNumber,
    [ActionConstants.APU_UPDATE_NON_MSA_SO_SERIAL_NUMBER]: ConfigureAPUReducer.updateNonMsaSOSerial,
    [ActionConstants.APU_UPDATE_NON_MSA_SO_NUMBER] : ConfigureAPUReducer.updateNonMsaServiceOrderNumber,
    [ActionConstants.APU_NONMSA_SO_ADD_CONFIGURATION] : ConfigureAPUReducer.addNonMsaServiceOrderConfiguration,
    [ActionConstants.APU_NONMSA_SO_DELETE_CONFIGURATION]: ConfigureAPUReducer.addNonMsaServiceOrderConfiguration,
    [ActionConstants.APU_NONMSA_SO_VALIDATE_API_ERROR]: ConfigureAPUReducer.apuNonMsaSoValidateApiError,
    [ActionConstants.APU_NONMSA_KEY_ONLY_UPDATE_SERIAL_NUMBER]: ConfigureAPUReducer.updateApuNonMsaKeyOnlySerialNumber,
    [ActionConstants.APU_NONMSA_KEY_ONLY_ADD_CONFIGURATION]: ConfigureAPUReducer.addApuNonMsaKeyOnlyConfiguration,
    [ActionConstants.APU_NONMSA_KEY_ONLY_DELETE_CONFIGURATION]: ConfigureAPUReducer.deleteApuNonMsaKeyOnlyConfiguration,
};

const initialState = {
    payload: {
        /* BEGIN: Mandatory fields for APU product configuration */

        customerType: CheckoutConstants.CUSTOMER_CATEGORY_MSA,  /* Setting Customer type default value to MSA for APU */
        apuactiveTab: 1, /* Active tab index in the APU product configuration modal */
        customerOrderType: '', /* Setting customer order type - Hardware via */
        customerOrderTypeErrorMessage: '',
        acceptTermsStatus: false, /* vaiable for accept product terms condition checkbox */
        acceptTermsErrorMsg: '', /* variable for accept product terms error message */
        enableNextBtn: false, /* based on this field we will enable/disable the NEXT button in configure product modal. */
        configureAPUModelOpen: false, /* using this show/hide the configure product model. */
        system: '', /* tells the Selected product is of which system, "Apptus" or "BMS" */
        categoryName: '', /* tells whether it is APU, ASPIRE, BMS */
        /* APU product configuration data */
        msaConfigData: [
            {
                soldTo: '',
                soldToError: '',
                contractNo: '',
                contractNumError: '',
                expirationDate: 'NA',
                aircraftOem: '131-9A',
                aircraftOemError: '',
                serialNumber: '',
                serialNumberError: '',
                unitPrice: 0.00,
                error: '',
                validInputData: false,
                subProductId: '',
            }
        ],
        nonMsaConfigData: [
            {
                acOem: '131-9A',
                oemError: '',
                serialNumber: '',
                serialNumberError: '',
                paymentOption: '',
                paymentOptionError: '',
                unitPrice: 0.00,
                extendedPrice: 0.00,
                validInputData: false,
                subProductId: '',
                purchaseOrderNumber: '',
                purchaseOrderNumberError: '',
                expiryDate: '',
                validateQuantity: ''
            }
        ],
        nonMsaServiceOrderConfigData: [
            {
                acOem: '131-9A',
                oemError: '',
                serialNumber: '',
                serialNumberError: '',
                serviceOrderNumber: '',
                serviceOrderNumberError: '',
                paymentOption: '',
                paymentOptionError: '',
                unitPrice: 0.00,
                extendedPrice: 0.00,
                validInputData: false,
                subProductId: ''

            }
        ],
        nonMsaKeyOnlyOrderConfigData: [
            {
                acOem: '131-9A',
                oemError: '',
                serialNumber: '',
                serialNumberError: '',
                paymentOption: '',
                paymentOptionError: '',
                unitPrice: 0.00,
                extendedPrice: 0.00,
                validInputData: false,
                subProductId: '',
                optionId: '',
                optionError:'',
                optionAvailable: false,
                term: ''
            }
        ],
        contractData: [{
            value: '',
            text: '',
        }],
        contractDetails: [{
            contractNo: '',
            expiryDate: '',
        }],

        /* APU Model types */
        aircraftOEMs: '131-9A',
        /* aircraftOEMs:[ { value: '131-9A', text: '131-9A' },
                //     { value: 'BOEING', text: 'BOEING' }
                ], */

        totalPrice: 0.0,

        /* END: Mandatory fields for APU product configuration */

        isFetching: true,
        isSuccess: false,
        purchaseType: 3,  /* Purchase type defines if APU purchase is based on Contract or Software purchase for NON MSA */
        product: {},
        productsInCart: [],  /* ALL the product in Cart are stored in the field. */
        redirectTo: undefined,
        editCartAPUProductDetails: {
            id: 0,
            seq: 0,
            cartSeq: 0,
            productSeq: 0
        },
        isContractDataFetching: true,
        isContractDataSuccess: false,
        contractExpireNotif: {
            notifDisplayFlag: false,
            notifDisplayMsg: '',
            notifStatus: false,
        },
        featuresMasterData: [],
        purchaseOrders: [],
        purchaseOrderDetails: [{
            distributionNo: '',
            endDate: '',
        }],
        isProductFetching: true,
        isProductFetchSuccess: false,
        showAPUValidationErrorMsg : true,
        isValidateServiceOrder: false,
        isValidateServiceOrderSuccess: true
    }
};

export const configAPUData = createReducer(initialState, apuConfigurationHandler);
